import { useState } from "react";
import { Search } from "lucide-react";
import { conditions } from "@/data/content";
import { SectionHeading, Reveal } from "@/components/motion";
import { scrollToSection } from "@/lib/scroll";

export const Conditions = () => {
  const [query, setQuery] = useState("");
  const filtered = conditions.filter((c) =>
    c.toLowerCase().includes(query.trim().toLowerCase())
  );

  return (
    <section id="conditions" className="bg-background py-16 sm:py-24 lg:py-32" data-testid="conditions-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <SectionHeading
            number="04"
            eyebrow="Medical Conditions"
            title="Medical Conditions Evaluated & Managed"
            sub="Dr. Suyash Bhadoriya provides evaluation and management for a wide range of adult medical conditions in Bhopal."
          />
          <Reveal delay={2} className="shrink-0 w-full lg:w-80">
            <label className="relative block">
              <span className="sr-only">Search conditions</span>
              <Search size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search a condition…"
                data-testid="conditions-search-input"
                className="w-full rounded-full border border-slate-300 bg-white pl-11 pr-4 py-3 text-sm text-slate-800 placeholder:text-slate-400 focus:border-teal-600 focus:outline-none transition-colors duration-200"
              />
            </label>
          </Reveal>
        </div>

        <div className="mt-10 flex flex-wrap gap-3" data-testid="conditions-list">
          {filtered.map((c, i) => (
            <Reveal key={c} delay={Math.min(i, 6) * 0.5}>
              <button
                onClick={() => scrollToSection("appointment")}
                data-testid={`condition-chip-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="rounded-full bg-white border border-slate-200 shadow-soft px-5 py-2.5 text-sm font-medium text-slate-700 hover:border-teal-500/50 hover:text-teal-800 hover:-translate-y-0.5 transition-[transform,border-color,color] duration-200"
              >
                {c}
              </button>
            </Reveal>
          ))}
          {filtered.length === 0 && (
            <p className="text-sm text-slate-500" data-testid="conditions-empty">
              No matching condition listed — please call the clinic to ask about your concern.
            </p>
          )}
        </div>

        <Reveal delay={1}>
          <p className="mt-8 text-sm text-slate-500 max-w-2xl leading-relaxed">
            This list is indicative, not exhaustive. If your condition is not listed, please
            contact the clinic — as an internal medicine physician, Dr. Bhadoriya evaluates a
            broad range of adult health concerns.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
